import React from "react";
import "./Footer.css";
import Image from "./BancoLogoGrey.png";
import Image2 from "./appstore.png";
import fb from "./facebook.png";
import InstagramIcon from "@material-ui/icons/Instagram";
import { Link } from "@material-ui/core";
import PhoneRoundedIcon from "@material-ui/icons/PhoneRounded";
import { useMediaQuery } from "@material-ui/core";

export const Footer = () => {
  const mobile = useMediaQuery("(max-width:768px)");
  return (
    <div className="FooterContainer">
      <div className={!mobile ? "leftContainer" : "leftContainerMob"}>
        <Link to="/work">
          <img src={Image} className="logoGrey" alt="logo" />
        </Link>

        <Link to="/work">
          <img src={Image2} className="appStore" alt="app" />
        </Link>
      </div>
      <div className="rightContainer">
        <div className="LinksF1">
          <Link href="/nosotros">Acerca de</Link>
          <Link href="/faq">FAQ</Link>
          <Link href="/Contacto">Contacto</Link>
          <Link href="/conduce">Sé un conductor</Link>
        </div>
        <div className="LinksF2">
          <Link href="/work">Legal</Link>
          <Link href="/work">Condiciones de uso</Link>
          <Link href="/work">Politicas de privacidad</Link>
        </div>
        <div className="social">
          <Link
            href="https://www.facebook.com/BlancoSeguroApp/"
            rel="noopener noreferrer"
            target="_blank"
            className="fb"
          >
            <img src={fb} className="fbLogo" alt="fbLogo" />
          </Link>
          <Link
            className="ins"
            href="https://www.instagram.com/blancoseguro/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <InstagramIcon></InstagramIcon>
          </Link>
          <a href="tel:50242890334">
            <PhoneRoundedIcon className="call"></PhoneRoundedIcon>
          </a>
        </div>
      </div>
      <div className="reserved">
        <p className="reservText">
          Blanco Seguro {new Date().getFullYear()}. Todos los derechos reservados. Desarrollado por
          <a
            href="https://softweare.com.ar"
            className="mangoLink"
            target="_blank"
            rel="noopener noreferrer"
          >
            SOFTWEARE.
          </a>
        </p>
      </div>
    </div>
  );
};
